import Vue from 'vue'

Vue.prototype.$removeValueArray = function(data_array) {
  var what = arguments
  var a = arguments
  var L = a.length
  var ax
  while (L && data_array.length) {
    what = a[--L]
    while ((ax = data_array.indexOf(what)) !== -1) {
      data_array.splice(ax, 1)
    }
  }
  return data_array
}
Vue.prototype.$isEmpty = function(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      return false
    }
  }
  return true
}
Vue.prototype.$sumArray = function(array) {
  var sum = 0
  for (var el in array) {
    if (array.hasOwnProperty(el)) {
      sum += parseFloat(array[el])
    }
  }
  return sum
}
Vue.prototype.$curDistance = function(lat1, lon1, lat2, lon2) {
  if ((lat1 === lat2) && (lon1 === lon2)) {
    return 0
  } else {
    var radlat1 = Math.PI * lat1 / 180
    var radlat2 = Math.PI * lat2 / 180
    var theta = lon1 - lon2
    var radtheta = Math.PI * theta / 180
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta)
    if (dist > 1) {
      dist = 1
    }
    dist = Math.acos(dist)
    dist = dist * 180 / Math.PI
    dist = dist * 60 * 1.1515
    dist = dist * 1.609344
    var curDistance = Math.round(dist * 1000)
    return curDistance
  }
}
Vue.prototype.$getObjectArray = function(array, field_obj, field, data = null) {
  if (data) {
    const object = array.find(obj => {
      return obj[field_obj] === field
    })
    if (object === undefined) {
      return array[0][data]
    } else {
      return object[data]
    }
  } else {
    return array.find(obj => {
      return obj[field_obj] === field
    })
  }
}
Vue.prototype.$stockCart = function(id, _storage = '_v2_cart', type = 'product') {
  var qty = 0
  var cart = {
    item: []
  }
  const LOCAL_DATA_CART = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + _storage)
  if (LOCAL_DATA_CART) {
    cart = JSON.parse(LOCAL_DATA_CART)
  }
  if (cart.item.length > 0) {
    for (var i = 0; i < cart.item.length; i++) {
      if (type === 'variant') {
        if (cart.item[i].product_variant_id && Number(cart.item[i].product_variant_id) === Number(id)) {
          qty = qty + Number(cart.item[i].qty)
        }
        if (cart.item[i].product_combo_id) {
          for (var y = 0; y < cart.item[i].product_combo_items.length; y++) {
            if (cart.item[i].product_combo_items[y].variant_id && Number(cart.item[i].product_combo_items[y].variant_id) === Number(id)) {
              qty = qty + (Number(cart.item[i].qty) * Number(cart.item[i].product_combo_items[y].qty))
            }
          }
        }
        if (cart.item[i].materials.length > 0) {
          for (let c = 0; c < cart.item[i].materials.length; c++) {
            const material = cart.item[i].materials[c]
            if (material.material_product_variant_id && Number(material.material_product_variant_id) === Number(id)) {
              qty = qty + Number(material.qty_in_cart)
            }
          }
        }
        if (cart.item[i].addons.length > 0) {
          for (let x = 0; x < cart.item[i].addons.length; x++) {
            const item_addons = cart.item[i].addons[x]
            if (item_addons.product_addon_variant_id && Number(item_addons.product_addon_variant_id) === Number(id)) {
              qty = qty + (Number(item_addons.product_addon_qty) * Number(cart.item[i].qty))
            }
          }
        }
      } else {
        if (cart.item[i].product_id && Number(cart.item[i].product_id) === Number(id)) {
          qty = qty + Number(cart.item[i].qty)
        }
        if (cart.item[i].product_combo_id) {
          for (var z = 0; z < cart.item[i].product_combo_items.length; z++) {
            if (cart.item[i].product_combo_items[z].id && Number(cart.item[i].product_combo_items[z].id) === Number(id)) {
              qty = qty + (Number(cart.item[i].qty) * Number(cart.item[i].product_combo_items[z].qty))
            }
          }
        }
        if (cart.item[i].materials.length > 0) {
          for (let c = 0; c < cart.item[i].materials.length; c++) {
            const material = cart.item[i].materials[c]
            if (material.material_product_id && Number(material.material_product_id) === Number(id)) {
              qty = qty + Number(material.qty_in_cart)
            }
          }
        }
        if (cart.item[i].addons.length > 0) {
          for (let x = 0; x < cart.item[i].addons.length; x++) {
            const item_addons = cart.item[i].addons[x]
            if (item_addons.product_addon_proudct_id && Number(item_addons.product_addon_proudct_id) === Number(id)) {
              qty = qty + (Number(item_addons.product_addon_qty) * Number(cart.item[i].qty))
            }
          }
        }
      }
    }
  }
  return qty
}
